<template>
    <div class="search-filter-select">
        <div :class="{'search-filter-select__input': true, 'is-open' : !isClose, 'is-empty': !hasChecked}"
              @click="setIsClose"
              ref="filterSelect">
            <span class="search-filter-select__input-text">{{ inputText }}</span>
            <ArrowIconDown class-name="search-filter-select__input-icon" />
        </div>
        <transition name="fade-up">
            <div v-show="!isClose"
                 class="search-filter-select__content-wrapper"
                 ref="filterSelectContent">
                <div class="search-filter-select__content-overlay" @click="hideContent" />
                <div class="search-filter-select__content">
                    <div class="search-filter-select__content-inner">
                        <div class="search-filter-select__items">
                            <CheckboxItem
                                v-for="checkbox in checkboxes"
                                modify="search-checkbox_theme_select"
                                :key="checkbox.id"
                                :title="checkbox.title"
                                :name="`${name}[${checkbox.id}]`"
                                :checked="checkbox.checked"
                                :disabled="checkbox.disabled"
                                :handle-click="_clickHandler"
                                :value="checkbox.value.toString()"
                                :is-tablet="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import ArrowIconDown from '../media/ArrowIconDown';
import CheckboxItem from '../CheckboxItem/CheckboxItem';

export default {
    name: 'SelectComponent',

    components: {
        CheckboxItem,
        ArrowIconDown
    },
    data() {
        return {
            isClose: true
        };
    },
    props: ['label', 'name', 'baseInputText', 'checkboxes'],

    computed: {
        checked() {
            return this.checkboxes.filter((item) => item.checked);
        },

        hasChecked() {
            return this.checked.length;
        },

        inputText() {
            if (!this.checked?.length) {
                return this.baseInputText || '';
            }

            return this.checked.map((item) => {
                return item.title;
            }).join(', ');
        }
    },

    mounted() {
        this.bindEvents();
    },
    methods: {
        bindEvents() {
            document.addEventListener('click', this.onClickOutside);
        },
        setIsClose() {
            this.isClose = !this.isClose;
        },
        hideContent() {
            this.isClose = true;
        },
        _clickHandler() {
            this.$emit('change');
        },
        onClickOutside(event) {
            const {filterSelectContent, filterSelect} = this.$refs;

            if (!this.isClose && !filterSelect.contains(event.target)) {
                if (event.target !== filterSelectContent && !filterSelectContent.contains(event.target)) {
                    this.isClose = true;
                }
            }
        },

        beforeDestroy() {
            document.removeEventListener('click', this.onClickOutside);
        }
    }
};
</script>


<style lang="scss">
@import 'SelectComponent';
</style>
